const COMMON_PARAMS: NComponentsParams.ICommonParams = {
  innerTemplateCode: '',
  templateCode: '',
  useBlocksFilters: false,
  blocksLimit: 0,
  useShowMore: false,
  useHeader: false,
  useBackgroundColor: null,
  useContainer: false,
  paddingTop: undefined,
  paddingBottom: undefined,
  isHorizontal: false,
  blockPerRow: 0,
  showMoreLink: '',
  useWhiteShowMoreLinkColor: false
}

const STEP_BOX_LIST_PARAMS: NComponentsParams.IStepBoxListParams = {
  isVertical: false
}

const COMPONENT_PARAMS: NComponentsParams.IComponentParams = {
  ...COMMON_PARAMS,
  ...STEP_BOX_LIST_PARAMS
}

export { COMMON_PARAMS, STEP_BOX_LIST_PARAMS, COMPONENT_PARAMS }
